export default __webpack_public_path__ + "static/media/deleteIcon.e251327e.svg";